import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get All Settings
   * @param {*} params Query Options
   */
  getAll(params) {
    return backofficeService.Api().get('api/organizations', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get All Settings
   * @param {*} params Query Options
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`api/organizations/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get All Settings
   * @param {*} params Query Options
   */
  getCurrent(id, params = {}) {
    return backofficeService.Api().get('organization/current', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  search(params = {}) {
    return backofficeService.Api().get('api/organizations', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * New Organization
   * @param {*} params Query Options
   */
  create(data) {
    return backofficeService.Api().post('api/organizations/new', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  update(id, data) {
    console.log('in update here')
    return backofficeService.Api().put(`api/organizations/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  bringStore(data) {
    return backofficeService.Api().put('api/organizations/moveOrganization', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
